import config from 'data/config'

const { platformConfig } = config.homepage

export const isStringPlatform = (platform) => typeof platform === 'string'
export const isObjectPlatform = (platform) => typeof platform === 'object'

export const orderPlatformIcons = (platforms) => {
  const formattedPlatforms = platforms?.map((platform) => {
    if (isStringPlatform(platform)) {
      const index = platformConfig[platform]?.order
      const wOrder = { platform, order: index }
      return wOrder
    } else if (isObjectPlatform(platform)) {
      const platKey = platform?.platform?.toLowerCase()
      const index = platformConfig[platKey]?.order
      const wOrder = { ...platform, order: index }
      return wOrder
    } else {
      return null
    }
  })

  const validatedPlatforms = formattedPlatforms?.filter((obj) => !!obj.platform)
  const sorted = validatedPlatforms?.sort((a, b) => a.order - b.order)

  return sorted
}

export const removeDupPlatforms = (allPlats) => {
  const noDupes = new Set()
  const seen = []

  allPlats.forEach((item) => {
    const platform = item?.platform?.toLowerCase()
    if (!noDupes.has(platform)) {
      seen.push(item)
      noDupes.add(platform)
    }
  })

  const newList = !!noDupes.size ? seen : []

  return newList
}
